module.exports = __webpack_public_path__ + "img/LEVANTO.356ce93b.png";